<!--  -->
<template>
  <div>
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="query.account_name" clearable style="width:200px;" placeholder="请输入公众号名称" />
        <!-- <el-input v-model="query.corp_id" clearable style="width:200px;margin:0px 10px" placeholder="请输入公众号appid" /> -->
        <!-- <el-input v-model="query.suite_id" clearable style="width:200px;" placeholder="请输入应用id" /> -->
        <el-select v-model="query.onlyMe" placeholder="请选择" style="width:200px;">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
    >
      <el-table-column
        prop="account_name"
        label="公众号名称"
        align="center"
        min-width="250px"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        align="center"
        min-width="250px"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>

    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { officialAccountlist } from '@/api/sourceMaterial.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        account_name: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内公众号'
      }, {
        value: 2,
        label: '我关联的公众号'
      }]
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await officialAccountlist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      // console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.account_name = null
      this.query.onlyMe = 2
      this.list()
    },
    choose(item) {
      this.$emit('official', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box{
  text-align: center;
}
</style>
